"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCreativeLead() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-creative-lead" className="bg-background text-foreground overflow-hidden py-24 md:py-32 lg:py-40">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`lg:col-span-5 xl:col-span-6 relative aspect-[3/4] md:aspect-[4/5] lg:aspect-[3/4] overflow-hidden transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582385/img/sophia_lee_creative_director_portrait.png" alt="Sophia Lee, Creative Director" className="absolute inset-0 w-full h-full object-cover grayscale contrast-110 brightness-95" />
            {}
            <div className="absolute inset-0 bg-black/5 mix-blend-multiply pointer-events-none" />
          </div>

          {}
          <div ref={contentRef} className={`lg:col-span-7 xl:col-span-6 flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-8 max-w-2xl">
              <div className="space-y-4">
                <span className="block text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-muted-foreground">
                  The Creative Lead
                </span>
                <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl italic tracking-tight text-foreground">
                  Sophia Lee
                </h2>
              </div>

              <Separator className="w-12 bg-foreground/20" />

              <div className="space-y-6 text-base md:text-lg leading-relaxed text-muted-foreground font-light">
                <p>
                  "I believe that true luxury lies in the unseen details—the seamless flow of an evening, the perfect placement of a stem, the quiet confidence of flawless execution. My approach blends sophisticated design concepts with meticulous coordination to curate spaces that feel both effortlessly elegant and deeply personal."
                </p>
                <p>
                  With over 10 years of experience in high-end event design, Sophia leads the Echelon Soiree team with a keen eye for elegance and innovation, ensuring every gathering is an unforgettable experience tailored to discerning clients.
                </p>
              </div>

              <div className="pt-8">
                <Button asChild size="lg" className="rounded-none px-8 h-14 text-sm tracking-widest uppercase group">
                  <Link to="/InquirePage">
                    Message Me
                    <ArrowRight className="ml-3 size-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}